import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "LEDService",
  controller: "LED",
};

const methods = [
  "AddLedEquipment",
  "UpdateLedEquipment",
  "DeleteLedEquipment",
  "GetLedEquipmentById",
  "GetLedEquipmentList",
  "GetItemPagingList",
  "FindLedPlan",
  "SaveLedPlan"
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
    if (path == "GetLedEquipmentById" || path =="FindLedPlan") {
      Fun.prototype[path] = function(data) {
        if(path == "GetLedEquipmentById"){
          const getPath = "GetLedEquipmentById?id=" + data;
          return this.get(getPath);
        }else if(path =="FindLedPlan"){
          const getPath = "FindLedPlan?id=" + data.id;
          return this.get(getPath);
        }
       
      };
    } else {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
    }
  });
};

const TranResourcesApi = ZJApi.defineNewApi("TranResourcesApi", factory);

export default TranResourcesApi;
